import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
} from "async-ops";
import { GET_FINDING_GROUP_LIST } from "../services/get-finding-group-list";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../../common_components/mdae-framework";
import { GET_AUDIT_GROUPS_FOR_FINDING_GROUP } from "../services/get-audit-groups-for-finding-group";
import { cloneDeepWith } from "lodash";

export const TOGGLE_FINDING_GROUP_LIST_ACTION_POPOVER =
  "TOGGLE_FINDING_GROUP_LIST_ACTION_POPOVER";
export const TOGGLE_ADD_FINDING_GROUP_POPUP = "TOGGLE_ADD_FINDING_GROUP_POPUP";
export const SET_FINDING_GROUP_FORM_DATA = "SET_FINDING_GROUP_FORM_DATA";
export const SET_AUDIT_GROUP_LISTS = "SET_AUDIT_GROUP_LISTS";
export const RESET_FINDING_GROUP_POPUP_VALIDATION =
  "RESET_FINDING_GROUP_POPUP_VALIDATION";

export const initialFindingGroupFormData = {
  findingGroupId: 0,
  name: "",
  description: "",
  defaultInd: false,
  curatedInd: false,
  selectedAuditGroupIds: [],
};

const initialState = {
  findingGroupList: [],
  findingGroupFormData: initialFindingGroupFormData,
  availableAuditGroups: [],
  mappedAuditGroups: [],
  isFindingGroupFormDataValid: true,
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case TOGGLE_FINDING_GROUP_LIST_ACTION_POPOVER:
    case TOGGLE_ADD_FINDING_GROUP_POPUP:
    case SET_AUDIT_GROUP_LISTS:
    case RESET_FINDING_GROUP_POPUP_VALIDATION:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_FINDING_GROUP_FORM_DATA:
      newState = cloneDeepWith(state);
      const findingGroupFormData = newState.findingGroupFormData
        ? newState.findingGroupFormData
        : {};
      for (let prop in action.data.findingGroupFormData) {
        findingGroupFormData[prop] = action.data.findingGroupFormData[prop];
      }
      newState = { ...newState, findingGroupFormData };
      return newState;
    case asyncTypes.OPERATION:
    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_FINDING_GROUP_LIST)(action)) {
        return { ...state, findingGroupList: [] };
      }
      if (isAsyncComplete(GET_FINDING_GROUP_LIST)(action)) {
        const response = action.response;
        return {
          ...state,
          findingGroupList: response.findingGroupList,
        };
      }
      if (isAsyncOperation(GET_AUDIT_GROUPS_FOR_FINDING_GROUP)(action)) {
        return { ...state, availableAuditGroups: [], mappedAuditGroups: [] };
      }
      if (isAsyncComplete(GET_AUDIT_GROUPS_FOR_FINDING_GROUP)(action)) {
        const response = action.response;
        return {
          ...state,
          availableAuditGroups: response.availableAuditGroups,
          mappedAuditGroups: response.mappedAuditGroups,
        };
      }
      return state;
    default:
      return state;
  }
}
